import { Component, Input, OnInit } from '@angular/core';
import { combineLatest, Subject } from 'rxjs';
import { CustomerModel } from 'src/app/models/customer-model';
import { ConfigService } from 'src/app/services/config/config.service';
import { EventsService } from 'src/app/services/event/event.service';
import { GameHubControllerService } from 'src/app/services/gameHub/game-hub-controller';
import { LastPlayedService } from 'src/app/services/lastplayed/lastplayed.service';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';

@Component({
  selector: 'app-last-played-games',
  templateUrl: './last-played-games.component.html',
  styleUrls: ['./last-played-games.component.scss'],
})
export class LastPlayedGamesComponent implements OnInit {
  @Input() componentType: any;

  private lobbyName: string;
  protected _recentGamesSubject: Subject<any>;
  public customer: CustomerModel;
  public heading: string = '';
  public lastPlayedGamesArray: any = [];

  constructor(
    private config: ConfigService,
    private lastPlayedService: LastPlayedService,
    private events: EventsService,
    private gameHubController: GameHubControllerService,
    private userSession: UserSessionService,
  ) {

  }

  ngOnInit() {

    combineLatest([
      this.userSession.getCustomer(),
      this.lastPlayedService.lastPlayed$
    ]).subscribe(([customer, games]) => {
      this.customer = customer;
      this.lastPlayedGamesArray = games;
    });

    this.lastPlayedService.refreshLastPlayed();

    this.heading = this.componentType == 'gallery' ? 'Recently played' : 'Last played games';

  }

  public launchCasinoGame(gameData) {
    this.events.publish("event:game:close");
    this.gameHubController.killAllInstances();
    setTimeout(() => {
      this.gameHubController.launchCasinoGame(gameData);
    }, 300);

  }
}
